import {useTranslation} from "react-i18next";
import UpsLivecamsText from "./UpsLivecamsText";

export const UpsLivecams = () => {
	const {t} = useTranslation();

	return (
		<div className="grid-2-col margin-vertical-2 margin-horizontal-1">
			<div className="flex-align-center flex-direction-column">
				<div className="margin-bottom-1 icon-background icon-live-color">
					<span className="font-size-2-half icon--ri live-line"></span>
				</div>
				<p className="reset-margin text-align-center">{t('Live-Cams')}</p>
				<small className="text-align-center">{t('Bei Deutschlands #1 seit 25+ Jahren')}</small>
			</div>
			<div className="flex-align-center flex-direction-column">
				<div className="margin-bottom-1 icon-background icon-chat-color">
					<span className="font-size-2-half icon--ri team-line"></span>
				</div>
				<p className="reset-margin text-align-center">{t('10.000+ Models')}</p>
				<small className="text-align-center">{t('Große Auswahl je nach Geschmack')}</small>
			</div>
			<div className="flex-align-center flex-direction-column">
				<div className="margin-bottom-1 icon-background icon-video-color">
					<span className="font-size-2-half icon--ri lock-line"></span>
				</div>
				<p className="reset-margin text-align-center">{t('Sicher & Diskret')}</p>
				<small className="text-align-center">{t('Zahlungen via Paypal & Verifizierung mit Ai')}</small>
			</div>
			<div className="flex-align-center flex-direction-column">
				<div className="margin-bottom-1 icon-background icon-heart-color">
					<span className="font-size-2-half icon--ri heart-line"></span>
				</div>
				<UpsLivecamsText/>
			</div>
		</div>
	)
}
